"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQuestState = void 0;
const QuestState_1 = require("../types/QuestState");
const WorldCharacter_1 = require("../classes/WorldCharacter");
const canWorldCharacterTurnInQuest_1 = require("./canWorldCharacterTurnInQuest");
const definables_1 = require("definables");
const getWorldState_1 = require("./state/getWorldState");
const getQuestState = (questID) => {
    const worldState = (0, getWorldState_1.getWorldState)();
    const worldCharacter = (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, worldState.values.worldCharacterID);
    const questInstances = worldCharacter.questInstances;
    const questInstance = questInstances[questID];
    if (typeof questInstance !== "undefined" &&
        questInstance.isCompleted === false &&
        (0, canWorldCharacterTurnInQuest_1.canWorldCharacterTurnInQuest)(worldCharacter.id, questID)) {
        return QuestState_1.QuestState.TurnIn;
    }
    if (typeof questInstance === "undefined") {
        return QuestState_1.QuestState.Accept;
    }
    if (typeof questInstance !== "undefined" &&
        questInstance.isStarted &&
        questInstance.isCompleted === false) {
        return QuestState_1.QuestState.InProgress;
    }
    if (typeof questInstance !== "undefined" && questInstance.isCompleted) {
        return QuestState_1.QuestState.Complete;
    }
    return null;
};
exports.getQuestState = getQuestState;
